const stripHTML = (htmlString) => htmlString.replace(/<[^>]+>/g, '');

export default stripHTML;
